import { ClassAttributes, createElement } from 'react';
import { RouteComponentProps } from 'react-router';

import RouteLifecycleWrapper from '../component/primitive/RouteLifecycleWrapper';
import { Consumer as ConfigConsumer } from '../context/config';
import { Consumer as DependencyConsumer } from '../context/dependency';
import { Consumer as HistoryConsumer } from '../context/history';
import { Consumer as StateConsumer } from '../context/state';
import { CreationSetDetailPage as _CreationSetDetailPage } from '../page/CreationSetDetailPage';

type UrlParams = {
  offerId: string;
  assignmentId: string;
};

type Props = ClassAttributes<HTMLElement> & RouteComponentProps<UrlParams>;

const CreationSetDetailPage = ({ match }: Props) => (
  <DependencyConsumer>
    {(_) => (
      <HistoryConsumer>
        {(history) => (
          <StateConsumer>
            {(state) => (
              <ConfigConsumer>
                {(config) => {
                  return (
                    <RouteLifecycleWrapper match={match} onMount={async () => {}} onUnmount={() => {}}>
                      <_CreationSetDetailPage
                        signedInUserId={state.authentication.signedInUser!.id}
                        offerId={match.params.offerId}
                        assignmentId={match.params.assignmentId || null}
                        onClickCreation={(_, creationId: string) => history.push(`/creations/${creationId}`)}
                        onClickProfile={(url: string) => {
                          const win = window.open(url, '_blank');
                          if (win !== null) {
                            win.focus();
                          }
                        }}
                        profileWebUrl={config.PROFILE_WEB_URL}
                      />
                    </RouteLifecycleWrapper>
                  );
                }}
              </ConfigConsumer>
            )}
          </StateConsumer>
        )}
      </HistoryConsumer>
    )}
  </DependencyConsumer>
);

export default CreationSetDetailPage;
